<template>
<div class="chapter">
<div class="inner_page">
<p class="epi"><a id="page_vi"><span class="txit">Behind every successful man there is a woman. Behind the fall of a successful man there is usually another woman.</span></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?0ec48cfc